import configUrl from '../config';

// 로그인 시 저장한 토큰을 모든 API 호출에 자동으로 붙여주는 fetch 래퍼.
// 각 컴포넌트에서 매번 Authorization 헤더를 직접 챙기다 보면 하나라도
// 빠뜨리기 쉬워서(실제로 예전에 그랬다) 한 곳으로 모았다.
export const getToken = () => localStorage.getItem('token');

export const apiFetch = (path, options = {}) => {
  const token = getToken();
  const headers = { ...(options.headers || {}) };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  if (options.body && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }
  return fetch(`${configUrl.apiUrl}${path}`, { ...options, headers });
};
